import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

import { UserModel } from '@/models/UserModel';
import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

const DataCenterDashboards = loadable(
  () => import('@/pages/DataCenter/DashboardTab')
); // prettier-ignore
const DataCenterOmniReportBuilder = loadable(
  () => import('@/pages/DataCenter/OmniReportBuilder')
); // prettier-ignore
const DataCenterViewDashboard = loadable(
  () => import('@/pages/DataCenter/ViewDashboard')
); // prettier-ignore
const DataCenterV3 = loadable(() => import('@/pages/DataCenter/v3')); // prettier-ignore
const RedirectToDataCenterV3 = loadable(
  () => import('@/pages/DataCenter/v3/RedirectToDataCenterV3')
); // prettier-ignore

export enum DataCenterRoutes {
  DataCenterDashboards = '/:domain/data-center/dashboards',
  DataCenterOmniReportBuilder = '/:domain/data-center/omni/report-builder',
  DataCenterViewDashboard = '/:domain/data-center/dashboards/:analytics_provider/:dashboard_id',
  DataCenterOverview = '/:domain/data-center',
  DataCenterAskAi = '/:domain/data-center/ask-ai',
  DataCenterCustomReports = '/:domain/data-center/custom-reports',
  DataCenterCategory = '/:domain/data-center/:categorySlug',
  DataCenterDashboard = '/:domain/data-center/:categorySlug/:dashboardId'
}

export const getDataCenterRoutes = (currentUser: UserModel): RouteObject[] => {
  if (
    !FeatureFlagService.isEnabled(ExacareFeature.DATA_CENTER_TAB) ||
    !currentUser.isDataCenterEnabled()
  ) {
    return [];
  }

  return [
    {
      path: DataCenterRoutes.DataCenterDashboards,
      element: (
        <RedirectToDataCenterV3>
          <DataCenterDashboards />
        </RedirectToDataCenterV3>
      )
    },
    {
      path: DataCenterRoutes.DataCenterViewDashboard,
      element: (
        <RedirectToDataCenterV3>
          <DataCenterViewDashboard />
        </RedirectToDataCenterV3>
      )
    },
    ...(FeatureFlagService.isEnabled(
      ExacareFeature.DATA_CENTER_OMNI_REPORT_BUILDER
    )
      ? [
          {
            path: DataCenterRoutes.DataCenterOmniReportBuilder,
            element: <DataCenterOmniReportBuilder />
          }
        ]
      : []),
    ...[
      DataCenterRoutes.DataCenterOverview,
      DataCenterRoutes.DataCenterAskAi,
      DataCenterRoutes.DataCenterCustomReports,
      DataCenterRoutes.DataCenterCategory,
      DataCenterRoutes.DataCenterDashboard
    ].map((path) => ({ path, element: <DataCenterV3 /> }))
  ];
};
